import libraryData from 'RootData/library'
import axios from 'axios'
import store from 'Store'

const state = {
  postprocessing: {},
  basepostprocessing: {}
}

const getters = {
  getState (state) {
    return state
  }
}

const actions = {
  async fetchData ({ commit }) {
    const currentScene = store.getters['scenes/getCurrentScene']
    commit('setPostprocessing', currentScene)

    const response = await axios
      .get(libraryData)
    commit('setBasePostprocessing', response.data)
  }
}

const mutations = {
  setPostprocessing (state, data) {
    state.postprocessing = data.postprocessing
  },
  setBasePostprocessing (state, data) {
    state.basepostprocessing = data.library.postprocessing
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
